// extracted by mini-css-extract-plugin
export var container = "br_f";
export var leftBlock = "br_dj";
export var map = "br_dk";
export var section = "br_d";